module.exports = __webpack_public_path__ + "static/media/pied-piper-square.0cfc239a.svg";